import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import { PlusSquare, PencilSquare } from 'react-bootstrap-icons';

class BlockGrants extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			searchCount: 0
		};
	}
	
	addBlockGrant() {
		this.props.navigate('/GradOffice/BlockGrants/new');
	}
	
	editBlockGrant(blockGrantId) {
		this.props.navigate('/GradOffice/BlockGrants/' + blockGrantId);		
	}

	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'BlockGrants',
			columns: exportColumns,
			entity: 'ADMISSIONS.BLOCK_GRANT',
			search: null,
			order: 'GRANT_ID'
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Block Grants</span>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='GradOffice_BlockGrants' table={blockGrantList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='140px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const blockGrantList = {
	query: { entity: 'ADMISSIONS.BLOCK_GRANT', search: null, order: 'GRANT_ID' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addBlockGrant()} />, accessor: 'id',
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editBlockGrant(props.row.values.GRANT_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'GRANT_ID', width: 50 },
		{ Header: 'Academic Year', accessor: 'ACADEMIC_YEAR', width: 100 },
		{ Header: 'Amount', accessor: 'AMOUNT', Cell: props => <div style={{ textAlign: 'right', paddingRight: '4px' }}>{props.parent.formatCurrency(props.value)}</div>, width: 125 },
		{ Header: 'Current', accessor: 'CURRENT_GRANT', width: 70 },
		{ Header: 'Last Modified', accessor: 'LAST_MODIF', Cell: props => props.parent.dateTimeToString(props.parent.getDate(props.value)), width: 150 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'GRANT_ID', width: 10 },
	{ Header: 'Academic Year', accessor: 'ACADEMIC_YEAR', width: 20 },
	{ Header: 'Amount', accessor: 'AMOUNT', width: 25 },
	{ Header: 'Current', accessor: 'CURRENT_GRANT', width: 14 },
	{ Header: 'Last Modified', accessor: 'LAST_MODIF', width: 30, format: 'yyyy-mm-dd hh:mm AM/PM' }
];

export default withRouter(BlockGrants);
